import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin, message } from 'antd';
import { getMoodleProgramDetails } from '../services/moodleService';
import { Training } from '../types/training';
import AILedTrainingDetails from './AILedTrainingDetails';
import TrainerLedTrainingDetails from './TrainerLedTrainingDetails';

const TrainingDetails: React.FC = () => {
    const { trainingId } = useParams<{ trainingId: string }>();
    const navigate = useNavigate();
    const [training, setTraining] = useState<Training | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (trainingId) {
            loadBasicDetails();
        }
    }, [trainingId]);

    const loadBasicDetails = async (): Promise<void> => {
        try {
            setLoading(true);
            const currentTraining = await getMoodleProgramDetails(trainingId as string);
            if (!currentTraining) {
                message.error('Training not found');
                navigate('/');
                return;
            }
            setTraining(currentTraining);
        } catch (error) {
            console.error('Error loading training basic details:', error);
            message.error('Failed to load training details');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div style={{ textAlign: 'center', padding: '100px 0' }}><Spin size="large" /></div>;
    if (!training) return null;

    // Route to the appropriate fresh component based on programType
    if (training.programType === 'TrainerLed') {
        return <TrainerLedTrainingDetails />;
    }

    return <AILedTrainingDetails />;
};

export default TrainingDetails;
